var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowerInstallment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 32.6828,
    ry: 32.5943,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 32.5944 32.6829)",
    fill: "#7256CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1634 76.1809C60.9445 76.962 62.2108 76.962 62.9919 76.1809L75.7198 63.453C76.5008 62.672 76.5008 61.4056 75.7198 60.6246C74.9387 59.8435 73.6724 59.8435 72.8913 60.6246L61.5776 71.9383L50.2639 60.6246C49.4829 59.8435 48.2166 59.8435 47.4355 60.6246C46.6545 61.4056 46.6545 62.672 47.4355 63.453L60.1634 76.1809ZM63.5776 47.1324L63.5776 45.1324L59.5776 45.1324L59.5776 47.1324L63.5776 47.1324ZM63.5776 74.7667L63.5776 47.1324L59.5776 47.1324L59.5776 74.7667L63.5776 74.7667Z",
    fill: "#16161E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6295 90.5681C52.5743 92.3564 56.9529 93.3519 61.5634 93.3519C78.9254 93.3519 93 79.2348 93 61.8205C93 44.4062 78.9254 30.2891 61.5634 30.2891C54.16 30.2891 47.3544 32.856 41.9829 37.1508",
    stroke: "#16161E",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerInstallment);
export default __webpack_public_path__ + "static/media/lower_installment.1cd0b4dd49054bd3ca653d8703de96ef.svg";
export { ForwardRef as ReactComponent };